import { render, staticRenderFns } from "./VisaForm.vue?vue&type=template&id=6fcc6938"
import script from "./VisaForm.vue?vue&type=script&lang=js"
export * from "./VisaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports